import { useStore } from '../../store/useStore';

export const QuestTracker = () => {
    const activeQuests = useStore((state) => state.activeQuests);

    if (activeQuests.length === 0) return null;

    return (
        <div style={{
            position: 'absolute',
            top: '20px',
            right: '20px',
            width: '250px',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '8px',
            padding: '15px',
            color: 'white',
            fontFamily: "'Inter', sans-serif",
            pointerEvents: 'none',
            backdropFilter: 'blur(5px)'
        }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#ffd700', textTransform: 'uppercase', letterSpacing: '1px' }}>Current Quests</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                {activeQuests.map((quest) => (
                    <div key={quest.id}>
                        <h4 style={{ margin: '0 0 5px 0', fontSize: '13px', fontWeight: 'bold' }}>{quest.title}</h4>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                            {quest.objectives.map((obj) => (
                                <div key={obj.id} style={{ fontSize: '12px', color: '#ccc', display: 'flex', justifyContent: 'space-between' }}>
                                    <span>- {obj.description}</span>
                                    <span>{obj.currentCount}/{obj.targetCount}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
